//
import { store } from '../../store'
import axios from 'axios';


export const products = {
    namespaced: true,
    state: {
        products: [],
        newProduct: null,
        updateProduct: null
     },
    getters: {
        allProducts: (state) => {
            //
            return state.products
        },
        getProduct: (state) => {
            //
            const data = state.products
        
            return data
        },
        searchProducts: state => (search) => {
            //
            const results = state.products.filter(({ product, shop, category, tags }) => product.toLowerCase().includes(search.toLowerCase()) || shop.toLowerCase().includes(search.toLowerCase()) || category.toLowerCase().includes(search.toLowerCase()) || tags.includes(search.toLowerCase()))

            // const allBusiness =  results.map(product => product.product)
            // const businesses  = [...new Set(allBusiness)]

            return results
            
        },
        searchBusinessProduct: state => (search) => {
            //
            const results = state.products.filter(({ product }) => product.toLowerCase().includes(search.toLowerCase()) )

            return results
        },
        newProduct: (state) => {
            return state.newProduct
        },
        updateProduct: (state) => {
            return state.updateProduct
        }
        // currentBusiness: state => (name) => {
        //     // if (shop) { return }
        
        //     const results = state.vendors.find(({ shop }) => shop.includes(name))
        
        //     return results
        // }
    },
    actions: {
        async getProducts({ state,commit },  shop ) {
            //
            let resp
            let data
            //
            const user = store.getters['auth/getUser'];

            if (user) {

                axios.get('/products/'+user.name).then((res)=>{
                    //
                    // data = res.data.filter((order) => order.payment !== null || order.payment.status == "success")
                    commit('updateProducts', res.data)
                  })

            } else if (shop) {

                axios.get('/products/'+shop).then((res)=>{
                    //
                    // data = res.data.filter((order) => order.payment !== null || order.payment.status == "success")
                    commit('updateProducts', res.data)
                  })

            }


            // commit('updateProducts', data)
        },
        async createProduct({ commit }, product){

            //
            axios.post('/product/', product).then((res)=>{
                //
                commit('createProduct', res.data)
            })



            // products
            store.dispatch('products/getProducts', product.shop)

            
        },
        async updateProduct({ commit }, { product, shop, update }){


            axios.patch('/product/'+product, update).then((res)=>{
                //
                commit('updateProduct', res.data)
            })

            store.dispatch('products/getProducts', shop)
            
        },
        clearNewUpdate({ commit }, type){

            //
            if (type=='new'){
                commit('clearNew')
            }else if (type =='update'){
                commit('clearUpdate')
            }

        },
        async productVisible({ commit }, { product, shop, status }){
            
            console.log(product)
            console.log(shop)

            if (product || shop) {

                const resp = await axios.post('/product/visible', { product: product, shop: shop, status })

                console.log(resp.data.productVisible)
            }

        },
        async productInvisible({ commit }, { product, shop, status }){

            console.log(product)
            console.log(shop)

            if (product || shop) {

                // console.log(data)
                const resp = await axios.post('/product/visible', { product: product, shop: shop, status })

                console.log(resp.data.productVisible)
            }

            

        },
        async productAvailable({ commit }, { product, shop, status }){
            if (product || shop) {

                const resp = await axios.post('/product/available', { product: product, shop: shop, status })

                console.log(resp.data.productAvailable)
            }  

        },
        async productUnavailable({ commit }, { product, shop, status }){
            if (product || shop) {4
                const resp = await axios.post('/product/available', { product: product, shop: shop, status })

                console.log(resp.data.productAvailable)
            }

        },
        async productLimited({ commit }, { product, shop, status }){
            if (product || shop) {
                
                const resp = await axios.post('/product/limited', { product: product, shop: shop, status })

                console.log(resp.data.limited)
            }

        },
        async productUnlimited({ commit }, { product, shop, status }){
            if (product || shop) {
                
                const resp = await axios.post('/product/limited', { product: product, shop: shop, status })

                console.log(resp.data.limited)
            }

        }
        
    },
    mutations: {
        updateProducts: (state, data) => {
            state.products = data
        },
        createProduct: (state, data) => {
            state.newProduct = data
        },
        updateProduct: (state, data) => {
            state.updateProduct = data
        },
        clearNew: (state) => {
            state.newProduct = null
        },
        clearUpdate: (state) => {
            state.updateProduct = null
        }
    }
}